import {
    put,
    takeLatest,
    call
} from 'redux-saga/effects'
import { delay } from 'redux-saga'
import { get } from 'lodash'
import fetch from '../api/fetch'
import {
    fetchLocations,
    getQuoteVariation,
    getRenewalVariation,
    getQuoteSingle,
    checkQuoteStep,
    removeSoftReferral
} from '../actions'

function* triggerFetchLocations(action: any) {
    yield put(fetchLocations(action.payload.riskLocation.quoteId))
}

function* triggerFetchLocationsDel(action: any) {
    try {
        yield call(fetch, `/quotes/${action.quoteId}/locations/${action.addressId}`, { method: 'DELETE' })
    } finally {
        yield put(fetchLocations(action.quoteId))
    }
}

function* triggerGetQuoteVariation(action: any) {
    yield call(delay, 250)
    yield put(getQuoteVariation(action.quoteId))
}

function* triggerGetRenewalVariation(action: any) {
    yield call(delay, 1000)
    yield put(getRenewalVariation(action.quoteId))
}

function* triggerGetQuoteSingle(action: any) {
    yield call(delay, 150)
    yield put(getQuoteSingle(action.quoteId))
}

function* triggerStep1(action: any) {
    try {
        yield put({ type: 'SET_STEP01_PENDING' })
        const response = yield call(fetch, `/quotes/step01`, { method: 'POST', body: action.content })
        yield put({
            type: 'SET_STEP01_FULFILLED',
            payload: response.policyCategories,
        })
        let quoteId = get(action.content, 'quote.id', '')
        if (quoteId !== '') {
            yield put(checkQuoteStep(action.content.quote.id))
        }
    } catch (error) {
        yield put({
            type: 'SET_STEP01_REJECTED',
            payload: error,
        })
    }
}

function* triggerStep4c(action: any) {
    yield call(delay, 250)
    yield put(checkQuoteStep(action.content.quote.id))
}

function* triggerStepCheckAlt(action: any) {
    yield call(delay, 250)
}

function* triggerRemoveSoftReferral(action: any) {
    yield call(delay, 1000)
    yield put(removeSoftReferral())
}

export const quoteSaga = [
    takeLatest('SET_STEP04', triggerStepCheckAlt),
    takeLatest('SET_STEP04c', triggerStep4c),
    takeLatest('SET_STEP03', triggerStepCheckAlt),
    takeLatest('SET_STEP01', triggerStep1),
    takeLatest('SET_STEP01_RENEWAL', triggerStepCheckAlt),
    takeLatest('SUBMIT_STEP02', triggerStepCheckAlt),
    takeLatest('ADD_LOCATIONS_FULFILLED', triggerFetchLocations),
    takeLatest('ADD_LOCATIONS_SECURITY_FULFILLED', triggerFetchLocations),
    takeLatest('DEL_LOCATION', triggerFetchLocationsDel),
    takeLatest('DEL_STEP05_QUOTE_VAR', triggerGetQuoteVariation),
    takeLatest('CREATE_STEP05_QUOTE_VAR', triggerGetQuoteVariation),
    takeLatest('CREATE_STEP05c_QUOTE_VAR', triggerGetQuoteVariation),
    takeLatest('ISSUE_STEP05_QUOTE_VAR', triggerGetQuoteVariation),
    takeLatest('ISSUE_VIEW_QUOTE_VAR', triggerGetQuoteSingle),
    takeLatest('UPDATE_STEP05_QUOTE_VAR', triggerGetQuoteVariation),
    takeLatest('UPDATE_STEP05_RENEWAL_VAR', triggerGetRenewalVariation),
    takeLatest('POST_STEP05_SOFT_REF_FULFILLED', triggerRemoveSoftReferral),
]



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/sagas/quote.ts